import { useSelector } from 'react-redux';
import { RootState } from 'common/redux/store';

export const useIsDark = (): boolean => {
  const themeMode = useSelector((state: RootState) => state?.theme?.themeMode);
  return themeMode === 'dark';
};
